// BÌNH LUẬN / TRẢ LỜI KÈM ẢNH (04/10/2026) — phần LOGIC THUẦN dùng chung (khối, runner, Boss, test).
//
// Ảnh lấy từ KHO ẢNH = ảnh của sản phẩm trong thư viện Sản phẩm trên Boss (bảng san_pham_anh). Bot lấy danh sách + tải ảnh bằng token bot
// (server/src/kho-anh.ts: chỉ ảnh của sản phẩm thuộc CHỦ của bot; kịch bản gắn sản phẩm thư viện → chỉ ảnh của sản phẩm đó).
//
// Mạng cho phép (căn cứ — xem chú thích từng khối):
//  · Facebook: ô bình luận / ô trả lời bình luận có nút đính ảnh (input[type=file] ẩn sau biểu tượng máy ảnh trong khung soạn) — LÀM.
//    Khảo sát thật 04/10: nút div[role=button] "Đính kèm một ảnh hoặc video" nằm trong khung form của ô bình luận/ô trả lời — ĐÃ ĐO (hình học).
//    VẪN GIẢ ĐỊNH (input file ẩn không có trong khảo sát; không được đăng thật): input[type=file] nằm TRONG khung soạn bao quanh ô Lexical; ảnh xem
//    trước là <img> blob:/data: trong khung soạn; bình luận đăng xong có <img> (thường trong a[href*="photo"]) trong div[role=article] của bình luận đó.
//  · X: ô trả lời tại chỗ có nút Ảnh — LÀM. Khảo sát thật 04/10: [data-testid=toolBar] có button "Thêm ảnh hoặc video" — ĐÃ ĐO; input
//    [data-testid=fileInput] ẩn, xem trước [data-testid=attachments] — VẪN GIẢ ĐỊNH; trả lời đăng xong có [data-testid=tweetPhoto] img (tweetPhoto ĐÃ ĐO).
//  · Reddit: ảnh trong bình luận CHỈ khi cộng đồng bật (nút ảnh trong thanh công cụ ô soạn) — LÀM CÓ KIỂM: không có nút → gửi chỉ chữ hoặc bỏ mục
//    theo tham số, lý do rõ. GIẢ ĐỊNH CHƯA ĐO: input[type=file] nằm trong comment-composer-host của ô đang soạn.
//  · YouTube, TikTok web: KHÔNG cho ảnh trong bình luận → khối không có tham số; sơ đồ/kế hoạch ghi kem_anh bị từ chối với câu LY_DO_KHONG_HO_TRO.
//
// Bundle: tham số kem_anh = "khong" (mặc định) → bước KHÔNG có khoá kem_anh → bundle y hệt bản cũ (hash không đổi). Có "luon"/"ti_le" → bước có
// khoá kem_anh (phần đã học) + bundle tự khai can_plugin = PLUGIN_CAN_KEM_ANH (src/shared/phien-ban-plugin.ts).
import type { Cond } from "./bundle";
import { kichThuocAnh } from "./san-pham";

export const KEM_ANH_CHE_DO = ["khong", "luon", "ti_le"] as const;
export type CheDoKemAnh = (typeof KEM_ANH_CHE_DO)[number];
export const KHI_LOI_ANH = ["chi_chu", "bo_muc"] as const;
export type KhiLoiAnh = (typeof KHI_LOI_ANH)[number];

/** Ảnh gửi kèm tối đa (byte) — Boss lưu ảnh đã thu nhỏ ≤ 290 KB nên thực tế nhỏ hơn nhiều; ngưỡng này chặn ảnh hỏng/ảnh lạ. */
export const ANH_KEM_BYTE_TOI_DA = 5 * 1024 * 1024;
export const ANH_KEM_MIME = ["image/jpeg", "image/png", "image/webp"] as const;
/** Không dùng lại CÙNG ảnh cho cùng nick (phạm vi tài khoản) trong N lượt gần nhất (khi kho còn ảnh khác). */
export const TRANH_LAP_MAC_DINH = 5;
export const TI_LE_ANH_MAC_DINH = 30;
/** Chờ ảnh xem trước hiện trong khung soạn (ms). */
export const CHO_XEM_TRUOC_MS = 15_000;
export const LY_DO_KHONG_HO_TRO = "mạng này không cho bình luận kèm ảnh";
/** Chọn ảnh xem trước mặc định trong khung soạn (ảnh vừa đính — blob:/data:). */
export const XEM_TRUOC_MAC_DINH = 'img[src^="blob:"], img[src^="data:"]';

// ---------- tham số khối (bản đồ v0 tự hiện trên sơ đồ) ----------
// anKhiRong: bỏ trống thì KHÔNG ghi vào sơ đồ (sơ đồ cũ không có khoá này → y nguyên); lúc lắp vẫn lấy macDinh.
export const TS_KEM_ANH = {
  ten: "kem_anh", kieu: "chuoi" as const, macDinh: "khong", anKhiRong: true, luaChon: [...KEM_ANH_CHE_DO],
  moTa: "gửi KÈM ẢNH sản phẩm (kho ảnh = ảnh của sản phẩm trong thư viện Sản phẩm trên Boss): khong = chỉ chữ (mặc định); luon = mọi câu kèm một ảnh; ti_le = mỗi câu kèm ảnh với xác suất ti_le_anh %",
};
export const TS_TI_LE_ANH = {
  ten: "ti_le_anh", kieu: "so" as const, macDinh: String(TI_LE_ANH_MAC_DINH), anKhiRong: true, min: 1, max: 100,
  moTa: "khi kem_anh = ti_le: phần trăm số câu được kèm ảnh (1-100)",
};
export const TS_KHI_LOI_ANH = {
  ten: "khi_loi_anh", kieu: "chuoi" as const, macDinh: "chi_chu", anKhiRong: true, luaChon: [...KHI_LOI_ANH],
  moTa: "khi không đính được ảnh (kho rỗng, ảnh lỗi/quá lớn, ô soạn không có nút đính ảnh): chi_chu = vẫn gửi chỉ chữ (mặc định); bo_muc = bỏ câu này",
};
// (05/10/2026) TẬP ẢNH người dùng chọn trong Kho ảnh (src/shared/kho-anh.ts): mã ảnh / album: / nhan: / sp:, cách nhau dấu phẩy. Rỗng = như trước
// (ảnh sản phẩm của kịch bản, AI chọn / xoay vòng). Có chọn → bot lấy NGẪU NHIÊN một ảnh trong tập (tránh lặp N lượt gần cho cùng nick).
export const TS_ANH_CHON = {
  ten: "anh_chon", kieu: "chuoi" as const, macDinh: "", anKhiRong: true,
  moTa: "khi kèm ảnh: TẬP ẢNH chọn trong Kho ảnh (mã ảnh ka-…/spa-…, album:<tên>, nhan:<tên>, sp:<mã sản phẩm>; cách nhau dấu phẩy) — bot lấy ngẫu nhiên một ảnh trong tập; bỏ trống = ảnh sản phẩm của kịch bản. AI KHÔNG tự điền ô này (người dùng chọn trên trang)",
};
export const TS_KEM_ANH_TAT_CA = [TS_KEM_ANH, TS_TI_LE_ANH, TS_ANH_CHON, TS_KHI_LOI_ANH];
export const TEN_TS_KEM_ANH = new Set(TS_KEM_ANH_TAT_CA.map((t) => t.ten));
/** Thao tác (theo mạng) có tham số kèm ảnh — khớp các khối (unit test đối chiếu với bản đồ v0). Gói seeding dùng để bật "Bình luận kèm ảnh". */
export const THAO_TAC_KEM_ANH: Readonly<Record<string, readonly string[]>> = {
  facebook: ["binh_luan_bai", "binh_luan_mot_bai", "tra_loi_mot_binh_luan", "tra_loi_binh_luan_bai_minh"],
  x: ["tra_loi", "binh_luan_mot_bai", "tra_loi_mot_bai", "tra_loi_phan_hoi"],
  reddit: ["binh_luan_mot_bai", "tra_loi_mot_binh_luan", "tim_roi_binh_luan"],
};
export const hoTroKemAnh = (mang: string, thaoTac: string): boolean => !!THAO_TAC_KEM_ANH[mang]?.includes(thaoTac);
/** (07/10/2026) Thao tác ĐĂNG BÀI có tham số kèm ảnh (ảnh đính vào hộp soạn bài trước khi gõ) — TÁCH khỏi THAO_TAC_KEM_ANH (bình luận / trả lời) để gói seeding
 *  ("Bình luận kèm ảnh") không đổi nghĩa. Cùng cơ chế kem_anh (chen_truoc, o_tep, hậu kiểm), cùng bộ tham số TS_KEM_ANH_TAT_CA. */
export const THAO_TAC_DANG_KEM_ANH: Readonly<Record<string, readonly string[]>> = {
  facebook: ["dang_bai_tuong"],
  x: ["dang_bai_anh"],
};

/** Phần đã học của bước gửi khi bật kèm ảnh. Các trường chữ có thể chứa {{…}} (đã thay lúc lắp). */
export interface CauHinhKemAnh {
  che_do: "luon" | "ti_le" | string;
  ti_le?: number | string;
  khi_loi?: KhiLoiAnh | string;
  /** Vị trí (trong actions của bước) của thao tác GÕ chữ; ảnh đính NGAY TRƯỚC thao tác này, vào khung soạn chứa ô của thao tác đó. */
  chen_truoc: number;
  /** css input file trong khung soạn (mặc định input[type=file]). */
  o_tep?: string;
  /** css ảnh xem trước trong khung soạn (mặc định XEM_TRUOC_MAC_DINH). */
  xem_truoc?: string;
  /** Hậu kiểm: bình luận vừa đăng có ảnh — {{cau_da_go}} = câu đã gõ thật (kể cả câu người duyệt sửa). */
  hau_kiem?: Cond[];
  /** Ngữ cảnh cho AI chọn ảnh hợp nội dung (vd "{{item.noi_dung}}"); câu bình luận lấy từ thao tác gõ. */
  ngu_canh?: string;
  tranh_lap?: number | string;
  /** (05/10/2026, plugin ≥ 0.1.54) Tập ảnh người dùng chọn (src/shared/kho-anh.ts docAnhChon). Thiếu / rỗng = ảnh sản phẩm của kịch bản như trước. */
  anh_chon?: string;
}

export function laCheDoBat(v: unknown): v is "luon" | "ti_le" {
  return v === "luon" || v === "ti_le";
}

/** Có cấu hình kèm ảnh ĐANG BẬT không (khoá kem_anh với che_do luon/ti_le và chen_truoc hợp lệ). */
export function laKemAnhBat(x: unknown): x is CauHinhKemAnh {
  if (!x || typeof x !== "object" || Array.isArray(x)) return false;
  const o = x as Record<string, unknown>;
  return laCheDoBat(o.che_do) && typeof o.chen_truoc === "number" && Number.isInteger(o.chen_truoc) && o.chen_truoc >= 0;
}

/**
 * Lúc LẮP (sinhKichBan): bỏ khoá kem_anh của mọi bước (kể cả bước con trong `con`) khi chế độ không bật → bundle y như trước khi có tính năng.
 * Trả bản đã lọc (không sửa đầu vào).
 */
export function locKemAnhLearned<T>(learned: T): T {
  const loc = (v: unknown): unknown => {
    if (Array.isArray(v)) return v.map(loc);
    if (!v || typeof v !== "object") return v;
    const out: Record<string, unknown> = {};
    for (const [k, x] of Object.entries(v as Record<string, unknown>)) {
      if (k === "kem_anh" && x && typeof x === "object" && !Array.isArray(x) && "chen_truoc" in x) {
        if (!laCheDoBat((x as Record<string, unknown>).che_do)) continue;
        out[k] = chuanCauHinh(x as Record<string, unknown>);
        continue;
      }
      out[k] = loc(x);
    }
    return out;
  };
  return loc(learned) as T;
}

// Chuẩn hoá số trong cấu hình (chữ "30" → 30) để bundle gọn, tất định.
function chuanCauHinh(o: Record<string, unknown>): Record<string, unknown> {
  const r: Record<string, unknown> = { ...o };
  if (r.che_do !== "ti_le") delete r.ti_le;
  else r.ti_le = tiLeHopLe(r.ti_le);
  if (r.khi_loi !== "bo_muc") delete r.khi_loi;
  if (typeof r.anh_chon !== "string" || !r.anh_chon.trim()) delete r.anh_chon; // không chọn ảnh → bundle y như trước khi có tính năng
  else r.anh_chon = r.anh_chon.trim();
  return r;
}

/** Tỉ lệ % hợp lệ: chữ/số → kẹp 0..100; không phải số → mặc định. */
export function tiLeHopLe(v: unknown): number {
  const n = typeof v === "number" ? v : typeof v === "string" && v.trim() ? Number(v) : NaN;
  if (!Number.isFinite(n)) return TI_LE_ANH_MAC_DINH;
  return Math.max(0, Math.min(100, Math.round(n)));
}

/** Câu này có kèm ảnh không: luon → có; ti_le → bốc với xác suất ti_le% (rnd ∈ [0,1)). */
export function quyetKemAnh(cfg: Pick<CauHinhKemAnh, "che_do" | "ti_le">, rnd: () => number): boolean {
  if (cfg.che_do === "luon") return true;
  if (cfg.che_do !== "ti_le") return false;
  const p = tiLeHopLe(cfg.ti_le);
  if (p <= 0) return false;
  if (p >= 100) return true;
  return rnd() * 100 < p;
}

export interface AnhKho {
  id: string;
  spId: string;
  spTen: string;
  moTa: string; // chú thích/nhãn ngắn (rỗng = chưa có)
  mime: string;
  kichThuoc: number;
}

/**
 * Ứng viên theo thứ tự ưu tiên: ảnh KHÔNG nằm trong N lượt gần nhất của nick (giữ thứ tự kho) trước; nếu mọi ảnh đều vừa dùng thì lấy ảnh
 * dùng LÂU NHẤT trước (ít lặp nhất). daDung: mã ảnh đã dùng, MỚI NHẤT TRƯỚC.
 */
export function ungVienAnh(ds: AnhKho[], daDung: string[], tranhLap = TRANH_LAP_MAC_DINH): AnhKho[] {
  const n = Math.max(0, Math.floor(Number(tranhLap) || 0));
  const gan = new Set(daDung.slice(0, n));
  const moi = ds.filter((a) => !gan.has(a.id));
  if (moi.length) return moi;
  const viTri = (id: string) => { const i = daDung.indexOf(id); return i < 0 ? Infinity : i; };
  return [...ds].sort((a, b) => viTri(b.id) - viTri(a.id));
}

/** Xoay vòng: ảnh chưa từng dùng (theo thứ tự kho) → ảnh dùng lâu nhất. */
export function chonXoayVong(ungVien: AnhKho[], daDung: string[]): AnhKho | null {
  if (!ungVien.length) return null;
  const chua = ungVien.find((a) => !daDung.includes(a.id));
  if (chua) return chua;
  return [...ungVien].sort((a, b) => daDung.indexOf(b.id) - daDung.indexOf(a.id))[0]!;
}

/** Ghi lượt dùng: đưa lên đầu, bỏ trùng, giữ tối đa 50. */
export function ghiDaDung(daDung: string[], id: string): string[] {
  return [id, ...daDung.filter((x) => x !== id)].slice(0, 50);
}

/** Kiểm ảnh tải về: mime THẬT theo byte đầu (jpeg/png/webp), kích thước ≤ ngưỡng. Trả mime hoặc lý do. */
export function kiemAnhTai(bytes: Uint8Array, toiDa = ANH_KEM_BYTE_TOI_DA): { mime: string } | { loi: string } {
  if (!bytes.length) return { loi: "ảnh rỗng (0 byte)" };
  if (bytes.length > toiDa) return { loi: `ảnh quá lớn (${(bytes.length / 1024 / 1024).toFixed(1)} MB, tối đa ${Math.round(toiDa / 1024 / 1024)} MB)` };
  const k = kichThuocAnh(bytes);
  if (!k) return { loi: "tệp không phải ảnh JPEG/PNG/WebP (sai định dạng)" };
  return { mime: k.mime };
}

/** Tên tệp gửi lên trang (không lộ mã nội bộ khó hiểu): anh-<mã>.<đuôi>. */
export function tenTepAnh(a: Pick<AnhKho, "id">, mime: string): string {
  const duoi = mime === "image/png" ? "png" : mime === "image/webp" ? "webp" : "jpg";
  return `anh-${a.id.replace(/[^A-Za-z0-9_-]/g, "").slice(0, 40) || "kem"}.${duoi}`;
}

/** Tên hiện cho người (nhật ký, Nháp, Chờ duyệt): "<sản phẩm> — <chú thích>" hoặc "<sản phẩm> (ảnh <mã>)". */
export function tenAnh(a: Pick<AnhKho, "id" | "spTen" | "moTa">): string {
  const mt = a.moTa.trim();
  return mt ? `${a.spTen} — ${mt}` : `${a.spTen} (ảnh ${a.id})`;
}

/** Lời nhắc cho AI chọn ảnh hợp nội dung — chỉ dùng khi có ≥ 2 ứng viên và ít nhất một ảnh có chú thích. */
export function promptChonAnh(ngucanh: string, cau: string, ungVien: AnhKho[]): { system: string; user: string } {
  return {
    system: 'Bạn chọn MỘT ảnh sản phẩm hợp nhất để gửi kèm một bình luận mạng xã hội, dựa trên chú thích ảnh. Chỉ trả JSON {"so": <số thứ tự ảnh>}. Không ảnh nào hợp rõ ràng thì chọn ảnh chung nhất (ảnh giới thiệu sản phẩm).',
    user: `Bài/bình luận đang trả lời: ${ngucanh.slice(0, 800)}\nCâu sẽ gửi: ${cau.slice(0, 500)}\nCác ảnh:\n${ungVien.map((a, i) => `${i + 1}. ${a.spTen}${a.moTa.trim() ? ` — ${a.moTa.trim()}` : " — (chưa có chú thích)"}`).join("\n")}`,
  };
}

/** Đọc số thứ tự AI trả; sai → null (máy xoay vòng). */
export function docSoAnh(raw: string, soUngVien: number): number | null {
  const m = /"so"\s*:\s*"?(\d+)/.exec(raw) ?? /^\s*(\d+)\s*$/.exec(raw);
  const n = m ? Number(m[1]) : NaN;
  return Number.isInteger(n) && n >= 1 && n <= soUngVien ? n - 1 : null;
}

/** Phần đã học "kem_anh" của một bước gửi (khối dùng): giá trị {{ts.*}} thay lúc lắp; che_do = khong → locKemAnhLearned bỏ cả khoá. */
export function kemAnhHoc(chenTruoc: number, hauKiem: Cond[], them: Partial<Pick<CauHinhKemAnh, "o_tep" | "xem_truoc" | "ngu_canh">> = {}): CauHinhKemAnh {
  return { che_do: "{{ts.kem_anh}}", ti_le: "{{ts.ti_le_anh}}", khi_loi: "{{ts.khi_loi_anh}}", anh_chon: "{{ts.anh_chon}}", chen_truoc: chenTruoc, ...them, hau_kiem: hauKiem };
}

/** Mã sản phẩm thư viện của kịch bản (knowledge.san_pham_thu_vien do dichSoDo ghi) — null = kịch bản không gắn sản phẩm thư viện. */
export function spIdCuaKnowledge(knowledge: Record<string, unknown> | undefined): string | null {
  const s = knowledge?.san_pham_thu_vien;
  if (typeof s !== "string") return null;
  try { const o = JSON.parse(s) as { id?: unknown }; return typeof o.id === "string" && /^sp-[a-z0-9]{6,24}$/.test(o.id) ? o.id : null; } catch { return null; }
}
